import React from "react"
import { ReCaptcha } from "react-recaptcha-google"
import Config from "Data"

export class Recaptcha extends React.Component {
  render() {
    return (
      <div>
        <ReCaptcha
          ref={(el) => {
            this.captchaObject = el
          }}
          size="normal"
          render="explicit"
          sitekey={"6Ld_t9UUAAAAAKaNPqShdPl9SxD5EB2XKRpfCCRJ"}
          onloadCallback={this.props.onLoadRecaptcha}
          dataCallback={this.props.verifyCallback}
          verifyCallback={this.props.verifyCallback}
        />
      </div>
    )
  }
}

export default Recaptcha
